import React, { Component } from 'react';
import { isEmpty } from '../../../Common/Common';

import Editbox from '../../../Part_Sample/Editbox';
import Top_Bar from '../../../Part_Sample/Top_Bar';

export default class Schedule_Step1_Name extends Component {
	constructor(props) {
		super(props);
		this.program = {};
		let schedule_name = '';
		if (!isEmpty(this.props.param.program)) {
			this.program = JSON.parse(JSON.stringify(this.props.param.program));
			schedule_name = this.props.param.program.name;
		}

		this.state = {
			schedule_name: schedule_name,
		}
	}

	handlePrevious = () => {
		this.props.content_handler('Schedule', this.props.param);
	}

	handleChangeScheduleName = (val) => {
		this.setState({ schedule_name: val })
	}

	handleRegister = () => {
		if (this.state.schedule_name == '') {
			window.app.showToast(this.props.receiver.getString('no_name'), 3000);
			return;
		}

		this.program.name = this.state.schedule_name;
		let param = this.props.param;
		param.program = this.program;
		let next_component = 'Schedule_Step2_Target';

		// If navigated from Schedule_Office_Summary
		if (param.from == 'Schedule_Office_Summary') {
			next_component = 'Schedule_Office_Summary';
			param.from = 'Schedule_Step3_Pattern'; // If navigated from adding new schedule
			if (this.props.param.program_id != null) param.from = 'Schedule';  // If navigated from edit schedule
		} else {
			param.from = 'Schedule_Step1_Name';
		}

		this.props.content_handler(next_component, param);
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('add_sched')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ height: this.props.height - 150 }}>
						<div style={{ width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto', textAlign: 'left', marginBottom: 20 }}>
							<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('schedule_step1_instr')}</span>
						</div>
						<div style={{ height: 65 }}>
							<div style={{ display: 'inline-block', width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto' }}>
								<Editbox id='schedule_name' style={{}} placeholder={this.props.receiver.getString('name')} inputType='text' onChange={(event) => this.handleChangeScheduleName(event.target.value)} value={this.state.schedule_name} />
							</div>
						</div>
					</div>

				</div>
			</div>
		)
	}
}